"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationFilterField = void 0;
var _FieldWrapper = require("../input-field-components/FieldWrapper");
var _react = _interopRequireWildcard(require("react"));
var _accLocationsComponents = require("@adsk/acc-locations-components");
var _useTranslations = require("../utils/i18n/useTranslations");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const LocationFilterField = _ref => {
  let {
    filters: filterBy,
    handleFilterChange,
    container
  } = _ref;
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const {
    isLoading
  } = (0, _accLocationsComponents.useLocations)();
  const [shouldIncludeSubLocation, setShouldIncludeSubLocation] = (0, _react.useState)(Boolean(filterBy.subLocationId));
  const filterValue = filterBy.locationId || filterBy.subLocationId;
  return /*#__PURE__*/_react.default.createElement(_FieldWrapper.FieldWrapper, {
    label: T.translate("issueAttributes.location"),
    loading: isLoading
  }, /*#__PURE__*/_react.default.createElement(_accLocationsComponents.LocationPicker, {
    container: container !== null && container !== void 0 ? container : undefined,
    clearable: true,
    multiple: true,
    selectedNodesIds: (typeof filterValue === "string" ? [filterValue] : filterValue) || [],
    includeSubLocations: shouldIncludeSubLocation,
    onNodeSelect: node => {
      let selected;
      if (!!node) {
        if (Array.isArray(node)) {
          selected = node.map(_ref2 => {
            let {
              id
            } = _ref2;
            return id;
          });
        } else {
          selected = node.id;
        }
      }
      handleFilterChange(shouldIncludeSubLocation ? {
        subLocationId: selected,
        locationId: undefined
      } : {
        locationId: selected,
        subLocationId: undefined
      });
    },
    onIncludeSubLocation: includeSubLocation => {
      setShouldIncludeSubLocation(includeSubLocation);
      handleFilterChange(includeSubLocation ? {
        subLocationId: filterBy.locationId,
        locationId: undefined
      } : {
        locationId: filterBy.subLocationId,
        subLocationId: undefined
      });
    }
  }));
};
exports.LocationFilterField = LocationFilterField;
//# sourceMappingURL=LocationFilterField.js.map